import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, inject, NgModule, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideRouter, RouterModule, withEnabledBlockingInitialNavigation, withViewTransitions } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { getAuthProviders } from '@evc/platform';

import { HeaderComponent, HeaderMenuItemComponent } from 'shared-components/desktop';

import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { appComponents } from './core/components';
import { sharedModules } from './shared-modules.lib';

@NgModule({
  declarations: [
    ...appComponents,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    OverlayModule,
    HeaderComponent,
    HeaderMenuItemComponent,
    ...sharedModules,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    OverlayModule,
    ...appComponents,
    ...sharedModules,
  ],
  providers: [
    provideAppInitializer(() => {
      if (environment.USE_CONNECT_PLATFORM && environment.cloudConnected) {
        inject(MsalService).initialize();
      }
    }),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation(), withViewTransitions()),
    environment.USE_CONNECT_PLATFORM && environment.cloudConnected ? [...getAuthProviders(environment)] : [],
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
